import 'css-chunk:src/app/containers/Home/ClientsView/ClientDetailView/ClientOffers.scss';export default {
  "clientOfersContainer": "_clientOfersContainer_f748u_1",
  "sampleCsvUrl": "_sampleCsvUrl_f748u_4",
  "uploadButton": "_uploadButton_f748u_7"
};